/**
 * Utility functions for working with environment variables
 */

/**
 * Get an environment variable and throw an error if it's not defined
 */
export function getEnvVar(name: string): string {
  const env = (import.meta as any).env as Record<string, string | boolean | undefined>;
  const value = env[name] as string | undefined;
  if (!value) {
    throw new Error(`Environment variable ${name} is not defined`);
  }
  return value;
}

/**
 * Check if all required environment variables are available
 */
export function checkRequiredEnvVars(requiredVars: string[]): { isAvailable: boolean; missingVars: string[] } {
  const env = (import.meta as any).env as Record<string, string | boolean | undefined>;
  const missingVars = requiredVars.filter(name => !env[name]);
  return {
    isAvailable: missingVars.length === 0,
    missingVars
  };
}
